
import { WeddingEventImage } from 'ignite360-core';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'comment-button',
})
export default class CommentButton extends Vue {
  @Prop({ required: true }) image!: WeddingEventImage;

  getCommentsCount() {
    return this.image?.comments?.length || '';
  }
}
